<template>
  <div id="main-nav" style="margin-top: -1rem !important;">
    <!--[if lte IE 9]>
    <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security.</p>
  	<![endif]-->
    <a href="#main-wrapper" id="backto-top" class="back-to-top">
      <i class="far fa-angle-double-up"></i>
    </a>

    <!-- Preloader Start Here -->
    <div id="preloader"></div>
    <!-- Preloader End Here -->

    <!-- <div id="rol-selector">
      <span class="primary"><u>Invertir</u></span> | <span><u>Crédito</u></span>
    </div> -->

    <!-- <div class="my_switcher d-none d-lg-block">
        <ul>
            <li title="Light Mode">
                <a href="javascript:void(0)" class="setColor light" data-theme="light">
                    <i class="fal fa-lightbulb-on"></i>
                </a>
            </li>
            <li title="Dark Mode">
                <a href="javascript:void(0)" class="setColor dark" data-theme="dark">
                    <i class="fas fa-moon"></i>
                </a>
            </li>
        </ul>
    </div> -->

    <div>
      <!--=====================================-->
      <!--=        Header Area Start       	=-->
      <!--=====================================-->
      <header class="header axil-header header-style-2">
        <div id="axil-sticky-placeholder"></div>
        <div :class="needsWhiteNavbar ? 'main-navbar' : ''" class="axil-mainmenu">
          <div class="container-fluid">
            <div class="header-navbar">
              <div class="header-logo">
                <router-link :to="{ name: 'home' }"><img :src="getLogo" alt="logo" class="fix-logo"
                    :class="(needsWhiteNavbar || needsBlackWhiteLogo) ? 'fix-logo-color' : ''"></router-link>
              </div>
              <div class="header-main-nav">
                <!-- Start Mainmanu Nav -->
                <nav class="mainmenu-nav" id="mobilemenu-popup">
                  <div class="d-block d-lg-none">
                    <div class="mobile-nav-header">
                      <div class="mobile-nav-logo">
                        <a @click.stop="goToPage('home')">
                          <img class="light-mode" :src="logo" alt="Site Logo">
                          <img class="dark-mode" :src="logo" alt="Site Logo">
                        </a>
                      </div>
                      <button class="mobile-menu-close" data-bs-dismiss="offcanvas"><i class="fas fa-times"></i></button>
                    </div>
                  </div>
                  <ul class="mainmenu">
                    <li class="hidden-md hidden-lg">
                      <router-link to="" @click.native="goToAppLogin">Inicia sesión</router-link>
                    </li>
                    <li class="hidden-md hidden-lg menu-item-has-children">
                      <a :class="needsWhiteNavbar ? 'black' : ''" href="javascript:void(0);">Regístrate</a>
                      <ul class="axil-submenu">
                        <li><a @click.stop="goToInvestorRegister">Quiero ser inversionista</a></li>
                        <li><a @click.stop="goToApplicantRegister">Quiero solicitar un Crédito</a></li>
                        <li><a @click.stop="goToSupplierRegister">Quiero ser proveedor</a></li>
                      </ul>
                    </li>
                    <li class="menu-item-has-children">
                      <a :class="needsWhiteNavbar ? 'black' : ''" href="javascript:void(0);">Quiero invertir</a>
                      <ul class="axil-submenu">
                        <li><router-link :to="{ name: 'investmentPlansPage' }">Planes (simulador)</router-link></li>
                        <li><router-link :to="{ name: 'yieldPage' }">Rendimiento</router-link></li>
                        <li><router-link :to="{ name: 'carteraVencida' }">Cartera</router-link></li>
                        <!-- <li><router-link :to="{ name: 'loyaltyProgramPage' }">Red de compromiso</router-link></li> -->
                      </ul>
                    </li>
                    <li class="menu-item-has-children">
                      <a :class="needsWhiteNavbar ? 'black' : ''" href="javascript:void(0);">Quiero un crédito</a>
                      <ul class="axil-submenu">
                        <li><router-link :to="{ name: 'forProductsPage' }">Ecotecnologías</router-link></li>
                        <li><router-link :to="{ name: 'forPersonalPage' }">Personal</router-link></li>
                        <li><router-link :to="{ name: 'forBusinessPage' }">PYME</router-link></li>
                      </ul>
                    </li>
                    <li class="menu-item-has-children">
                      <a :class="needsWhiteNavbar ? 'black' : ''" href="javascript:void(0);">Sostenibilidad</a>
                      <ul class="axil-submenu">
                        <li><router-link :to="{ name: 'strategyPage' }">Estrategia</router-link></li>
                        <li><router-link :to="{ name: 'impactPage' }">Impacto</router-link></li>
                      </ul>
                    </li>
                  </ul>
                </nav>
                <!-- End Mainmanu Nav -->
              </div>
              <div class="header-action">
                <ul class="list-unstyled">
                  <li class="header-btn">
                    <router-link to="" @click.native="goToAppLogin" class="axil-btn btn-fill-black fix-white bold ">Inicia
                      Sesión</router-link>
                  </li>
                  <li class="header-btn">
                    <ul class="mainmenu">
                      <li class="menu-item-has-children">
                        <router-link :class="needsWhiteNavbar ? 'black' : ''" href="javascript:void(0);" to=""
                          class="axil-btn btn-fill-primary fix-white black bold ml--2 p-0">Regístrate</router-link>
                        <ul class="axil-submenu">
                          <li><a @click.stop="goToInvestorRegister">Quiero ser inversionista</a></li>
                        <li><a @click.stop="goToApplicantRegister">Quiero solicitar un Crédito</a></li>
                        <li><a @click.stop="goToSupplierRegister">Quiero ser proveedor</a></li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li class="mobile-menu-btn sidemenu-btn d-lg-none d-block">
                    <button class="btn-wrap btn-dark" data-bs-toggle="offcanvas" data-bs-target="#mobilemenu-popup">
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainNav",
  data() {
    return {
      sticky: false,
      mobileToggle: false,
      logo: "https://cdn.redgirasol.com/green/LOGOS/redgirasol-black-green.png",
      logoBW: "https://cdn.redgirasol.com/green/LOGOS/redgirasol-black-white.png",
      logoWhite: "https://cdn.redgirasol.com/green/LOGOS/redgirasol-white.png",
      logoWhiteGreen: "https://cdn.redgirasol.com/green/LOGOS/redgirasol.png"
    }
  },
  async mounted() {
    window.addEventListener('scroll', this.handleScroll);
    await this.mobileMenuActivation();
  },
  computed: {
    currentStep() {
      return this.$route.name;
    },
    needsWhiteNavbar() {
      return this.currentStep == "strategyPage"
              || this.currentStep == "loyaltyProgramPage"
              || this.currentStep == "impactPage";
    },
    needsBlackWhiteLogo() {
      return (
        this.currentStep == "reporteCuitf17"
        || this.currentStep == "reporteRoboExtravio"
        || this.currentStep == "seguimientoReporteRoboExtravio"
        || this.currentStep == "seguridad"
        || this.currentStep == "aclaraciones"
        || this.currentStep == "calificacion"
        || this.currentStep == "carteraVencida"
        || this.currentStep == "estadosFinancieros"
        || this.currentStep == "buroEntidadesFinancieras"
        || this.currentStep == "terminosCondiciones"
        || this.currentStep == "avisoPrivacidad"
        || this.currentStep == "comisiones"
        || this.currentStep == "yieldPage"
        || this.currentStep == "contratoMercantilSolicitante"
        || this.currentStep == "contratoMercantilInversionista"
        || this.currentStep == "contratoMercantilInstalador"
      );
    },
    getLogo() {
      if (this.needsWhiteNavbar) {
        return this.logoWhite;
      } else if (this.needsBlackWhiteLogo) {
        return this.logoBW;
      } else {
        return this.logo;
      }

    }
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 70) {
        this.sticky = true
      } else if (window.scrollY < 70) {
        this.sticky = false
      }
    },
    async goToPage(page) {
      await this.$router.push({
        name: page
      });
      this.mobileToggle = false;
    },
    mobileMenuActivation() {
      $('.menu-item-has-children > a').append('<span class="submenu-toggle-btn"></span>');

      $('.menu-item-has-children > a .submenu-toggle-btn').on('click', function (e) {

        var targetParent = $(this).parents('.mainmenu-nav'),
          target = $(this).parent().siblings('.axil-submenu'),
          targetSiblings = $(this).parents('.menu-item-has-children').siblings().find('.axil-submenu');

        if (targetParent.hasClass('offcanvas')) {
          $(target).slideToggle(400);
          $(targetSiblings).slideUp(400);
          $(this).parents('.menu-item-has-children').toggleClass('open');
          $(this).parents('.menu-item-has-children').siblings().removeClass('open');
        }

      });

      $(window).on('resize', function () {
        this.resizeClassAdd();
      });

      this.resizeClassAdd();
    },
    resizeClassAdd() {
      if (window.matchMedia('(min-width: 992px)').matches) {
        $('body').removeClass('mobilemenu-active');
        $('#mobilemenu-popup').removeClass('offcanvas show').removeAttr('style');
        $('.axil-mainmenu .offcanvas-backdrop').remove();
        $('.axil-submenu').removeAttr('style');
      } else {
        $('body').addClass('mobilemenu-active');
        $('#mobilemenu-popup').addClass('offcanvas');
        $('.menu-item-has-children > a').on('click', function (e) {
          e.preventDefault();
        });
      }
    }
  }
}
</script>

<style>
#main-navbar {
  margin-top: -1rem !important;
}

.main-navbar .mainmenu>li>a,
.main-navbar .mainmenu>li>a::after {
  color: var(--color-white) !important;
}

.axil-sticky .mainmenu>li>a.black,
.axil-sticky .mainmenu>li>a.black::after {
  color: var(--color-black) !important;
}

.white-logo {
  background-image: url("https://cdn.redgirasol.com/green/LOGOS/redgirasol.png");
}

#rol-selector {
  background-color: var(--color-black);
  min-height: 1rem;
  padding: 5px 0 5px 0;
  text-align: center;
  color: var(--color-white);
  font-size: 0.9rem;
}

.img-responsive {
  margin: auto;
}

.menu-spacer {
  background-color: #222232;
  width: 100%;
  height: 1px;
}

/* 
.offcanvas-menu ul li ul {
  margin-left: 15px;
  width: 100%;
  padding-top: 15px;
}
.offcanvas-menu ul li ul li {
}

.drop_menu {
	background:#005555;
	padding:0;
	margin:0;
	list-style-type:none;
	height:40px;
	background-image:url('bg.jpg');
}
.drop_menu li { float:left; }
.drop_menu li a {
	padding:12px 20px;
	display:block;
	color:#fff;
	text-decoration:none;
	font:12px arial, verdana, sans-serif;
	border-right:1px solid #75809a;
}

.drop_menu ul {
	position:absolute;
	left:-9999px;
	top:-9999px;
	list-style-type:none;
}
.drop_menu li:hover { position:relative; background:#75809a;  }
.drop_menu li:hover ul {
	left:0px;
	top:38px;
	background:#75809a;
	padding:0px;
}

.drop_menu li:hover ul li a {
	padding:10px;
	display:block;
	width:168px;
	text-indent:15px;
	background-color:#75809a;
}
.drop_menu li:hover ul li a:hover { background:#005555;  } */
.menu__wrapper ul.dropdown-right li .main__dropdown-menu,
.menu__wrapper ul.dropdown-right li:hover .main__dropdown-menu,
.menu-area .menu-full-width .main-menu .menu__wrapper ul.dropdown-right li .main__dropdown-menu {
  min-width: 230px;
  left: auto;
  right: 0;
  padding: 15px 25px;
}

.f-w {
  width: 100%;
}

.logo-right-button {
  padding-right: 50px;
}

a.fix-white {
  font-size: 14px;
  font-weight: 400;
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.mainmenu>li {
  margin: 0 0px !important;
}

.mainmenu {
  justify-content: flex-start !important;
}

.menu-item-has-children {
  padding-right: 1.5rem;
}

.axil-header .header-navbar .header-main-nav {
  margin: 0 55px 0 0px !important;
}

@media only screen and (min-width:1024px) {
  .p-0 {
    padding: 0;
  }
}

@media only screen and (max-width:500px) {
  .main-navbar .mainmenu>li>a, .main-navbar .mainmenu>li>a {
    color: var(--color-black) !important;
  }
}

.axil-mainmenu.axil-sticky img.fix-logo-color {
  content: url("https://cdn.redgirasol.com/green/LOGOS/redgirasol-black-green.png") !important;
}
</style>